var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-suggest_question" }, [
    _c("img", { attrs: { src: require("@/assets/ai_robot.svg"), alt: "" } }),
    _c(
      "div",
      { staticClass: "c-suggest_question__content" },
      [
        _c("div", { staticClass: "title label" }, [_vm._v("你可能想问")]),
        _vm.suggestQuestionListProp.length
          ? _c("el-scrollbar", { staticClass: "c-scrollbar" }, [
              _c(
                "div",
                { staticClass: "list_wrap" },
                _vm._l(_vm.suggestQuestionListProp, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "list_wrap__item",
                      on: {
                        click: function ($event) {
                          return _vm.$emit("on-send-suggest-question", item)
                        },
                        mouseenter: function ($event) {
                          _vm.isMouse = true
                        },
                        mouseleave: function ($event) {
                          _vm.isMouse = false
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "left_wrap" }, [
                        _c("img", {
                          staticClass: "icon",
                          attrs: {
                            src: require("@/components/aiChat/images/svg/jinghaoIcon.svg"),
                          },
                        }),
                        _c(
                          "div",
                          { staticClass: "question-content" },
                          [
                            _c("Tooltip", {
                              staticClass: "label",
                              attrs: { data: item, keyName: "label" },
                            }),
                            _vm.$store.state.aiChat.zzpSelectBtn &&
                            _vm.$store.state.aiChat.zzpSelectBtn.length > 0
                              ? _c(
                                  "p",
                                  { staticClass: "current-reference-text" },
                                  [
                                    _vm._v(" 当前引用： "),
                                    _vm._l(
                                      _vm.$store.state.aiChat.zzpSelectBtn,
                                      function (tool, i) {
                                        return _c("span", { key: i }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.btnListConfig[tool.type]
                                              ) +
                                              "； "
                                          ),
                                        ])
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _c("img", {
                        staticClass: "icon right_wrap one",
                        attrs: {
                          src: require("@/components/aiChat/images/svg/xiangyoujiantouIcon2.svg"),
                        },
                      }),
                      _c("img", {
                        staticClass: "icon right_wrap two",
                        attrs: {
                          src: require("@/components/aiChat/images/svg/xiangyoujiantouIcon.svg"),
                        },
                      }),
                    ]
                  )
                }),
                0
              ),
            ])
          : _vm._e(),
      ],
      1
    ),
    _c("p", { staticClass: "c-suggest_question__hint" }, [
      _vm._v(
        _vm._s(
          _vm.sourceType === "wenshu"
            ? "我可以帮你查询数据的问题，试试问我吧~"
            : "我可以帮你解答系统功能和操作使用方面的问题，试试问我吧~"
        )
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }